// LUMINA · pages/vajra/admin/FinanceSection.jsx
// Phase 39D: extracted from AdminHub.jsx — 财务收支 (4-account finance system)

import React, { useState, useEffect, useCallback } from 'react';
import {
  API, GD, DG, CR, TXT, PANEL,
  ACC_LABELS, ACC_ICONS, ACC_COLORS,
  INCOME_CATS, EXPENSE_CATS,
} from '../constants';
import { VajraBtn } from '../primitives';

export default function FinanceSection({ token, headers, eventList }) {
  const [finRecords, setFinRecords] = useState({records:[],balance_cad:0,income_cad:0,expense_cad:0,accounts:{}});
  const [finForm, setFinForm] = useState({
    direction:"income", category:"法会报名费", amount_cad:"",
    description:"", record_date:new Date().toISOString().slice(0,10),
    account_type:"btf_general", target_zh:"", event_id:"", payment_src:"etransfer", handler:"",
  });
  const [finMsg, setFinMsg] = useState("");
  const [finFilter, setFinFilter] = useState({account:"", direction:"", event_id:""});
  const [editingFinId, setEditingFinId] = useState(null);
  const [editFinForm, setEditFinForm] = useState({});

  const loadFinance = useCallback(async () => {
    const params = new URLSearchParams();
    if (finFilter.event_id) params.set('event_id', finFilter.event_id);
    const qs = params.toString();
    const url = `${API}/vajra/admin/finance${qs ? '?' + qs : ''}`;
    const fin = await fetch(url,{headers}).then(r=>r.ok?r.json():{records:[],balance_cad:0,income_cad:0,expense_cad:0,events:[]}).catch(()=>({records:[],balance_cad:0,income_cad:0,expense_cad:0,events:[]}));
    setFinRecords(fin);
  }, [token, finFilter.event_id]);

  useEffect(() => { loadFinance(); }, [loadFinance]);

  const submitFinance = async (e) => {
    e.preventDefault();
    const r = await fetch(`${API}/vajra/admin/finance`,{method:"POST",headers,body:JSON.stringify({...finForm,amount_cad:parseFloat(finForm.amount_cad)})});
    if(r.ok){ setFinMsg("✓ 已记录"); loadFinance(); setFinForm({...finForm,amount_cad:"",description:""}); }
    else { const d=await r.json(); setFinMsg("✗ "+(d.detail||"失败")); }
  };

  const deleteFinRecord = async (id) => {
    if(!window.confirm("确认删除此条记录？")) return;
    await fetch(`${API}/vajra/admin/finance/${id}`,{method:"DELETE",headers});
    loadFinance();
  };

  // ── inline edit ──
  const startEditFin = (r) => {
    setEditingFinId(r.id);
    setEditFinForm({
      direction: r.direction, category: r.category, amount_cad: String(r.amount_cad),
      description: r.description || '', record_date: r.record_date,
      account_type: r.account_type, target_zh: r.target_zh || '',
      event_id: r.event_id || '', payment_src: r.payment_src || '',
      handler: r.handler || '',
    });
  };
  const saveEditFin = async () => {
    const r = await fetch(`${API}/vajra/admin/finance/${editingFinId}`, {
      method: 'PUT', headers,
      body: JSON.stringify({...editFinForm, amount_cad: parseFloat(editFinForm.amount_cad)}),
    });
    if (r.ok) { setFinMsg("✓ 已保存"); setEditingFinId(null); loadFinance(); }
    else { const d = await r.json(); setFinMsg("✗ " + (d.detail || "保存失败")); }
  };

  return (
    <div>
      {/* 四账户余额卡片 */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:16}}>
        {Object.keys(ACC_LABELS).map(acc=>{
          const data = (finRecords.accounts||{})[acc] || {income_cad:0,expense_cad:0,balance_cad:0};
          const {color,bg} = ACC_COLORS[acc];
          return (
            <div key={acc} style={{background:bg,borderRadius:10,padding:"14px 16px",border:`1px solid ${color}22`,textAlign:"center"}}>
              <div style={{fontSize:16,marginBottom:4}}>{ACC_ICONS[acc]}</div>
              <div style={{fontSize:11,color,letterSpacing:.5,marginBottom:6}}>{ACC_LABELS[acc]}</div>
              <div style={{fontSize:20,color,fontFamily:"'Inter',sans-serif",fontWeight:700}}>${data.balance_cad}</div>
              <div style={{fontSize:10,color:"#aaa",marginTop:4}}>入${data.income_cad} 出${data.expense_cad}</div>
            </div>
          );
        })}
      </div>

      {/* 法会维度收支卡片 */}
      {(finRecords.events||[]).length > 0 && !finFilter.event_id && (
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:"#aaa",marginBottom:8,letterSpacing:1.2,textTransform:"uppercase"}}>按法会</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:8}}>
            {(finRecords.events||[]).slice(0,6).map(ev=>{
              const bal = ev.balance_cad;
              return (
                <div key={ev.event_id} style={{
                  background:bal>=0?"rgba(6,78,59,0.04)":"rgba(185,28,28,0.04)",
                  borderRadius:8,padding:"10px 14px",
                  border:`1px solid ${bal>=0?"rgba(6,78,59,0.15)":"rgba(185,28,28,0.15)"}`,
                  cursor:"pointer",
                }} onClick={()=>setFinFilter({...finFilter,event_id:String(ev.event_id)})}>
                  <div style={{fontSize:12,color:"#1F2937",fontWeight:500,marginBottom:4,
                    overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                    {ev.event_title}
                  </div>
                  <div style={{display:"flex",gap:8,fontSize:11,flexWrap:"wrap"}}>
                    <span style={{color:"#059669"}}>+${ev.income_cad}</span>
                    <span style={{color:"#DC2626"}}>-${ev.expense_cad}</span>
                    <span style={{fontWeight:600,color:bal>=0?DG:CR}}>
                      =${bal}
                    </span>
                  </div>
                  <div style={{fontSize:10,color:"#999",marginTop:2}}>{ev.count} 笔</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* 总计 + 导出 */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
        <div style={{fontSize:13,color:TXT}}>
          总余额：<span style={{fontWeight:700,color:finRecords.balance_cad>=0?DG:CR,fontFamily:"'Inter',sans-serif"}}>${finRecords.balance_cad}</span>
          <span style={{fontSize:11,color:"#aaa",marginLeft:10}}>收入 ${finRecords.income_cad} · 支出 ${finRecords.expense_cad}</span>
        </div>
        <button onClick={async ()=>{
          const r=await fetch(`${API}/vajra/admin/finance/export`,{headers});
          if(!r.ok){alert("导出失败");return;}
          const blob=await r.blob();
          const url=URL.createObjectURL(blob);
          const a=document.createElement("a");
          a.href=url;a.download=`lumina_finance_${new Date().toISOString().slice(0,10)}.xlsx`;
          document.body.appendChild(a);a.click();
          document.body.removeChild(a);URL.revokeObjectURL(url);
        }} style={{padding:"6px 16px",background:DG,color:"#fff",border:"none",borderRadius:7,fontSize:12,cursor:"pointer",letterSpacing:.5}}>
          导出 Excel ↓
        </button>
      </div>

      {/* 新增记录表单 */}
      <div style={{background:PANEL,borderRadius:12,padding:"20px",border:`1px solid rgba(0,0,0,0.06)`,marginBottom:20}}>
        <div style={{fontSize:13,color:GD,marginBottom:14}}>新增收支记录</div>
        {finMsg&&<div style={{fontSize:13,padding:"8px 12px",borderRadius:8,marginBottom:12,
          background:finMsg.startsWith("✓")?"rgba(6,78,59,0.06)":"rgba(107,26,26,0.06)",
          color:finMsg.startsWith("✓")?DG:CR}}>{finMsg}</div>}
        <form onSubmit={submitFinance}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
            <div>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>收支方向</label>
              <select value={finForm.direction} onChange={e=>setFinForm({...finForm,direction:e.target.value,category:e.target.value==="income"?"法会报名费":"场地租金"})}
                style={{width:"100%",padding:"9px 13px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,background:"rgba(255,255,255,0.9)"}}>
                <option value="income">收入</option>
                <option value="expense">支出</option>
              </select>
            </div>
            <div>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>账户</label>
              <select value={finForm.account_type} onChange={e=>setFinForm({...finForm,account_type:e.target.value})}
                style={{width:"100%",padding:"9px 13px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,background:"rgba(255,255,255,0.9)"}}>
                {Object.entries(ACC_LABELS).map(([k,v])=><option key={k} value={k}>{ACC_ICONS[k]} {v}</option>)}
              </select>
            </div>
          </div>

          {/* 账户专属字段 */}
          {(finForm.account_type==="monastery_fund"||finForm.account_type==="teacher_fund")&&(
            <div style={{marginBottom:12}}>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>
                {finForm.account_type==="monastery_fund"?"寺庙名称":"上师名称"}
              </label>
              <input value={finForm.target_zh} onChange={e=>setFinForm({...finForm,target_zh:e.target.value})}
                placeholder={finForm.account_type==="monastery_fund"?"如：多幸寺":"如：堪钦仁波切"}
                style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
            </div>
          )}
          {finForm.account_type==="event_fund"&&(
            <div style={{marginBottom:12}}>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>关联法会</label>
              <select value={finForm.event_id} onChange={e=>setFinForm({...finForm,event_id:e.target.value})}
                style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,background:"#fff"}}>
                <option value="">不关联</option>
                {eventList.map(ev=><option key={ev.id} value={ev.id}>{ev.title_zh}</option>)}
              </select>
            </div>
          )}

          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
            <div>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>类别</label>
              <select value={finForm.category} onChange={e=>setFinForm({...finForm,category:e.target.value})}
                style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,background:"#fff"}}>
                {(finForm.direction==="income"?INCOME_CATS:EXPENSE_CATS).map(c=><option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>金额 (CAD $)</label>
              <input type="number" min="0" step="0.01" value={finForm.amount_cad} onChange={e=>setFinForm({...finForm,amount_cad:e.target.value})}
                placeholder="0.00" required
                style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
            </div>
          </div>

          {finForm.direction==="income"&&(
            <div style={{marginBottom:12}}>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>收款方式</label>
              <select value={finForm.payment_src} onChange={e=>setFinForm({...finForm,payment_src:e.target.value})}
                style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,background:"#fff"}}>
                {[["etransfer","E-Transfer"],["paypal","PayPal"],["wechat","微信"],["cash","现金"],["other","其他"]].map(([k,l])=><option key={k} value={k}>{l}</option>)}
              </select>
            </div>
          )}

          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
            <div>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>经手人</label>
              <input value={finForm.handler} onChange={e=>setFinForm({...finForm,handler:e.target.value})}
                placeholder="如：Jack"
                style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
            </div>
            <div>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>日期</label>
              <input type="date" value={finForm.record_date} onChange={e=>setFinForm({...finForm,record_date:e.target.value})}
                style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
            </div>
            <div>
              <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>备注（选填）</label>
              <input value={finForm.description} onChange={e=>setFinForm({...finForm,description:e.target.value})}
                placeholder="简短说明…"
                style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
            </div>
          </div>
          <VajraBtn variant="gold" type="submit">记录{finForm.direction==="income"?"收入":"支出"}</VajraBtn>
        </form>
      </div>

      {/* Phase 113: BTF/Teacher/Temple/Event aggregation summary */}
      {(()=>{
        const ACC_TARGET = [
          {key:"btf_general",   zh:"供养BTF",    en:"BTF General",   color:"#D4AF37"},
          {key:"teacher_fund",  zh:"供养上师",   en:"Teacher Fund",  color:"#7c3aed"},
          {key:"monastery_fund",zh:"供养寺院",   en:"Monastery Fund",color:"#059669"},
          {key:"event_fund",    zh:"法会专项",   en:"Event Fund",    color:"#2563eb"},
        ];
        const recs = Array.isArray(finRecords.records) ? finRecords.records : [];
        const grandIncome = recs.filter(r=>r.direction==="income").reduce((s,r)=>s+(r.amount_cad||0),0);
        return (
          <div style={{marginBottom:24}}>
            <div style={{fontSize:11,letterSpacing:2,color:"#aaa",marginBottom:12}}>
              {localStorage.getItem("lumina_lang")==="zh" ? "供养流向总览" : "OFFERING ALLOCATION SUMMARY"}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:12}}>
              {ACC_TARGET.map(s=>{
                const total = recs.filter(r=>r.account_type===s.key&&r.direction==="income").reduce((acc,r)=>acc+(r.amount_cad||0),0);
                return (
                  <div key={s.key} style={{background:s.color+"12",border:`1px solid ${s.color}30`,borderRadius:10,padding:"14px 16px"}}>
                    <div style={{fontSize:11,color:s.color,letterSpacing:1,marginBottom:4}}>
                      {localStorage.getItem("lumina_lang")==="zh" ? s.zh : s.en}
                    </div>
                    <div style={{fontSize:20,fontWeight:700,color:s.color}}>${total.toLocaleString()}</div>
                    {grandIncome>0&&<div style={{fontSize:10,color:"#aaa",marginTop:2}}>{Math.round(total/grandIncome*100)}%</div>}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })()}

      {/* 收支明细 */}
      <div style={{background:PANEL,borderRadius:12,padding:"18px 20px",border:`1px solid rgba(0,0,0,0.06)`}}>
        {/* Filters */}
        <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
          <div style={{fontSize:11,color:"#aaa",letterSpacing:1.2,textTransform:"uppercase"}}>收支明细</div>
          <select value={finFilter.account} onChange={e=>setFinFilter({...finFilter,account:e.target.value})}
            style={{padding:"4px 10px",borderRadius:6,border:"1px solid rgba(0,0,0,0.15)",fontSize:11,background:"#fff"}}>
            <option value="">全部账户</option>
            {Object.entries(ACC_LABELS).map(([k,v])=><option key={k} value={k}>{ACC_ICONS[k]} {v}</option>)}
          </select>
          <select value={finFilter.direction} onChange={e=>setFinFilter({...finFilter,direction:e.target.value})}
            style={{padding:"4px 10px",borderRadius:6,border:"1px solid rgba(0,0,0,0.15)",fontSize:11,background:"#fff"}}>
            <option value="">全部方向</option>
            <option value="income">收入</option>
            <option value="expense">支出</option>
          </select>
          <select value={finFilter.event_id} onChange={e=>setFinFilter({...finFilter,event_id:e.target.value})}
            style={{padding:"4px 10px",borderRadius:6,border:"1px solid rgba(0,0,0,0.15)",fontSize:11,background:"#fff",maxWidth:200}}>
            <option value="">全部法会</option>
            {(finRecords.events||[]).map(ev=>(
              <option key={ev.event_id} value={ev.event_id}>{ev.event_title} (${ev.balance_cad})</option>
            ))}
          </select>
          <span style={{fontSize:11,color:"#bbb"}}>
            ({(finRecords.records||[]).filter(r=>
              (!finFilter.account||r.account_type===finFilter.account)&&
              (!finFilter.direction||r.direction===finFilter.direction)
            ).length} 条)
          </span>
        </div>
        {(finRecords.records||[]).length===0&&<div style={{fontSize:13,color:"#ccc",textAlign:"center",padding:"16px 0"}}>暂无记录</div>}
        {(finRecords.records||[])
          .filter(r=>
            (!finFilter.account||r.account_type===finFilter.account)&&
            (!finFilter.direction||r.direction===finFilter.direction)
          )
          .map(r=>{
            const acc = r.account_type||"btf_general";
            const ac = ACC_COLORS[acc]||ACC_COLORS.btf_general;
            const isEditingFin = editingFinId === r.id;
            if (isEditingFin) {
              const inp = (field, placeholder, type='text') => (
                <input type={type} value={editFinForm[field]||''}
                  onChange={e=>setEditFinForm({...editFinForm,[field]:e.target.value})}
                  placeholder={placeholder}
                  style={{padding:"4px 8px",border:"1px solid rgba(0,0,0,0.15)",borderRadius:4,fontSize:11,width:"100%",boxSizing:"border-box"}}/>
              );
              const sel = (field, options) => (
                <select value={editFinForm[field]||''} onChange={e=>setEditFinForm({...editFinForm,[field]:e.target.value})}
                  style={{padding:"4px 6px",border:"1px solid rgba(0,0,0,0.15)",borderRadius:4,fontSize:11}}>
                  {options.map(o=><option key={o.v||o} value={o.v||o}>{o.l||o}</option>)}
                </select>
              );
              return (
                <div key={r.id} style={{padding:"8px 0",borderBottom:"1px solid rgba(212,175,55,0.15)",background:"rgba(212,175,55,0.03)"}}>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:6,alignItems:"center"}}>
                    {sel('direction',[{v:'income',l:'收入'},{v:'expense',l:'支出'}])}
                    {sel('account_type',['event_fund','btf_general','monastery_fund','teacher_fund'].map(k=>({v:k,l:ACC_LABELS[k]})))}
                    {sel('category', (editFinForm.direction==='income'?INCOME_CATS:EXPENSE_CATS))}
                    <input type="number" min="0" step="0.01" value={editFinForm.amount_cad||''}
                      onChange={e=>setEditFinForm({...editFinForm,amount_cad:e.target.value})}
                      style={{width:70,padding:"4px 6px",border:"1px solid rgba(0,0,0,0.15)",borderRadius:4,fontSize:11}}/>
                    <input type="date" value={editFinForm.record_date||''}
                      onChange={e=>setEditFinForm({...editFinForm,record_date:e.target.value})}
                      style={{padding:"4px 6px",border:"1px solid rgba(0,0,0,0.15)",borderRadius:4,fontSize:11}}/>
                  </div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:6,alignItems:"center"}}>
                    {inp('target_zh','对象/收款人')}
                    {inp('handler','经手人')}
                    {inp('description','备注')}
                  </div>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <button onClick={saveEditFin} style={{padding:"4px 12px",background:DG,color:"#fff",border:"none",borderRadius:5,fontSize:11,cursor:"pointer"}}>保存</button>
                    <button onClick={()=>setEditingFinId(null)} style={{padding:"4px 12px",background:"transparent",color:"#999",border:"1px solid #ddd",borderRadius:5,fontSize:11,cursor:"pointer"}}>取消</button>
                  </div>
                </div>
              );
            }
            return (
              <div key={r.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"9px 0",borderBottom:"1px solid rgba(0,0,0,0.04)",fontSize:13}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2,flexWrap:"wrap"}}>
                    <span style={{padding:"1px 7px",borderRadius:8,fontSize:11,
                      background:r.direction==="income"?"rgba(6,78,59,0.1)":"rgba(107,26,26,0.1)",
                      color:r.direction==="income"?DG:CR}}>
                      {r.direction==="income"?"收入":"支出"}
                    </span>
                    <span style={{padding:"1px 7px",borderRadius:8,fontSize:11,background:ac.bg,color:ac.color}}>
                      {ACC_ICONS[acc]}{ACC_LABELS[acc]}
                    </span>
                    <span style={{color:"#555"}}>{r.category}</span>
                    {r.event_title&&<span style={{padding:"1px 6px",borderRadius:4,fontSize:10,background:"rgba(212,175,55,0.1)",color:GD}}>{r.event_title}</span>}
                    {r.target_zh&&<span style={{color:"#aaa",fontSize:11}}>· {r.target_zh}</span>}
                    {r.description&&<span style={{color:"#aaa",fontSize:11}}>· {r.description}</span>}
                  </div>
                  <span style={{fontSize:11,color:"#bbb"}}>{r.record_date}{r.handler ? ` · ${r.handler}` : ''} · {r.recorded_by}</span>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:10,marginLeft:12}}>
                  <span style={{fontSize:15,fontWeight:700,
                    color:r.direction==="income"?DG:CR,fontFamily:"'Inter',sans-serif"}}>
                    {r.direction==="income"?"+":`-`}${r.amount_cad}
                  </span>
                  <button onClick={()=>startEditFin(r)}
                    style={{background:"none",border:"none",color:"#ccc",cursor:"pointer",fontSize:14,lineHeight:1}}>✎</button>
                  <button onClick={()=>deleteFinRecord(r.id)}
                    style={{background:"none",border:"none",color:"#ddd",cursor:"pointer",fontSize:16,lineHeight:1}}>×</button>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}
